import React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import { match as matchPropTypes } from "react-router-prop-types";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useLocation } from "react-router-dom";
import ImportsView from "./imports";

export default function Imports({ match }) {
  const location = useLocation();
  const baseUrl = location.pathname.split("/imports-history")[0];

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle
          heading="Podgląd importu"
          breadcrumbs={[
            { title: "Historia importów", link: `${baseUrl}/imports-history` },
          ]}
        />
        <ImportsView match={match} />
      </CSSTransitionGroup>
    </>
  );
}

Imports.propTypes = {
  match: matchPropTypes.isRequired,
};
